import { formatDateLocal } from "../../../karyawan/helpers/timeline";
export const columnsDataDevelopment = [
  {
    Header: "No",
    accessor: "__index", // virtual accessor
  },
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Waktu Dibuat",
    accessor: "created_at",
    Cell: (value) => formatDateLocal(value),
  },
  {
    Header: "Waktu Diperbarui ",
    accessor: "updated_at",
    Cell: (value) => formatDateLocal(value),
  },
];
